import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import Box from "@amzn/awsui-components-react/polaris/box";
import StatusIndicator from "@amzn/awsui-components-react/polaris/status-indicator";
import { Drug, Prescription } from "./journey-types";
import { mapPrescriptionStatus } from "./journey-status-utils";
import FillTimeline from "./FillTimeline";

interface DrugJourneyCardProps {
  drug: Drug;
}

function PrescriptionSection({ prescription, index }: { prescription: Prescription; index: number }) {
  const statusConfig = mapPrescriptionStatus(prescription.prescriptionStatus);

  return (
    <div style={{
      padding: "20px",
      backgroundColor: "#ffffff",
      borderRadius: "12px",
      border: "1px solid #e9ebed",
      boxShadow: "0 1px 4px rgba(0,0,0,0.03)",
    }}>
      <SpaceBetween size="m">
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              backgroundColor: "#e8f5e9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 700,
              color: "#388e3c",
            }}>
              {index + 1}
            </div>
            <div>
              <Box fontSize="body-s" color="text-body-secondary">Prescription</Box>
              <Box fontSize="body-s" fontWeight="bold">{prescription.prescriptionId}</Box>
            </div>
            <StatusIndicator type={statusConfig.type}>{statusConfig.label}</StatusIndicator>
          </div>
        </div>

        {prescription.fills.length > 0 ? (
          <SpaceBetween size="m">
            {prescription.fills.map((fill) => (
              <FillTimeline key={fill.fillId} fill={fill} />
            ))}
          </SpaceBetween>
        ) : (
          <Box color="text-body-secondary" fontSize="body-s" textAlign="center" padding="m">
            No fills for this prescription
          </Box>
        )}
      </SpaceBetween>
    </div>
  );
}

const DrugJourneyCard: React.FC<DrugJourneyCardProps> = ({ drug }) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description={`Drug ID: ${drug.drugId}`}
        >
          <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "20px" }}>💊</span>
            {drug.drugName}
          </span>
        </Header>
      }
    >
      {drug.prescriptions.length > 0 ? (
        <SpaceBetween size="l">
          {drug.prescriptions.map((prescription, idx) => (
            <PrescriptionSection
              key={prescription.prescriptionId}
              prescription={prescription}
              index={idx}
            />
          ))}
        </SpaceBetween>
      ) : (
        <Box color="text-body-secondary" textAlign="center" padding="xl">
          No prescriptions found for this drug
        </Box>
      )}
    </Container>
  );
};

export default DrugJourneyCard;
